import type { Action, ActionReducerMap } from '@ngrx/store';

import * as fromSnackbar from './snackbar/snackbar.reducer';
import * as fromLoading from './loading/loading.reducer';
import * as fromUI from './ui/ui.reducer';
import type { CoreState } from './core.state';
import { entityTypesReducer } from './entity-types/entity-types.reducer';
import { measurementUnitsReducer } from './measurement-units/measurement-units.reducer';
import { messagesReducer } from './messages/messages.reducer';

export const coreReducer: ActionReducerMap<CoreState, Action> = {
  snackbarState: fromSnackbar.reducer,
  loadingState: fromLoading.reducer,
  uiState: fromUI.reducer,
  entityTypes: entityTypesReducer,
  measurementUnits: measurementUnitsReducer,
  messages: messagesReducer
};
